<template>
  <div class="relative">
    <AppLabel v-if="label" :for="id"
      >{{ label }} <AppRequiredLabel v-if="required"
    /></AppLabel>
    <div
      :class="[
        'min-h-[42px] border border-0.5 bg-grey-10 dark:bg-dark-surface rounded-md px-3 py-2 inline-flex w-full',
        error ? 'border-red-2 dark:border-dark-red' : 'border-grey-11 dark:border-dark-border',
        'focus-within:border-black dark:focus-within:border-dark-ink  ',
        disabled ? 'cursor-not-allowed bg-grey-9 dark:bg-dark-surface-2' : '',
      ]"
    >
      <mdicon
        v-if="icon"
        :name="icon"
        :aria-label="icon"
        class="text-grey-5 dark:text-dark-ink-muted pr-2 content-center"
        :size="20"
        aria-hidden="true"
      />
      <input
        :id="id"
        :type="type"
        :value="modelValue"
        :placeholder="placeholder"
        :step="type === 'number' ? step : undefined"
        :min="type === 'number' ? min : undefined"
        :disabled="disabled"
        :required="required"
        :aria-label="label || placeholder"
        :aria-invalid="!!error"
        :aria-describedby="
          error ? `${id}-error` : helpLabel ? `${id}-help` : undefined
        "
        :class="[
          'w-full text-sm bg-transparent outline-hidden',
          'disabled:text-grey-5 dark:disabled:text-dark-ink-muted disabled:opacity-100',
          'focus:ring-0',
          disabled ? 'cursor-not-allowed bg-grey-9 dark:bg-dark-surface-2' : '',
        ]"
        @input="$emit('update:modelValue', $event.target.value)"
      />
      <button
        v-if="showClearButton && modelValue && !disabled"
        data-click-outside-ignore
        type="button"
        class="text-grey-5 dark:text-dark-ink-muted hover:text-grey-3 dark:hover:text-dark-ink p-1 transition-colors content-center"
        aria-label="Clear input"
        @click="$emit('update:modelValue', '')"
      >
        <mdicon
          name="close"
          :size="20"
          aria-hidden="true"
        />
      </button>
      <mdicon
        v-if="error"
        name="alert-circle-outline"
        class="text-red-1 dark:text-dark-red pr-2"
        aria-hidden="true"
      />
    </div>
    <AppErrorLabel v-if="error" :id="`${id}-error`" class="mt-1" role="alert"
      >{{ error }}
    </AppErrorLabel>
    <AppHelpLabel v-if="helpLabel" :id="`${id}-help`" class="mt-1"
      >{{ helpLabel }}
    </AppHelpLabel>
  </div>
</template>

<script setup>
defineProps({
  modelValue: {
    type: [String, Number],
    default: '',
  },
  helpLabel: {
    type: String,
    default: '',
  },
  label: {
    type: String,
    default: '',
  },
  icon: {
    type: String,
    default: '',
  },
  placeholder: {
    type: String,
    default: '',
  },
  type: {
    type: String,
    default: 'text',
  },
  step: {
    type: Number,
    default: 0.01,
  },
  min: {
    type: Number,
    default: 0,
  },
  error: {
    type: String,
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  required: {
    type: Boolean,
    default: false,
  },
  showClearButton: {
    type: Boolean,
    default: false,
  },
  id: {
    type: String,
    default: () => `input-${Math.random().toString(36).substr(2, 9)}`,
  },
})

defineEmits(['update:modelValue'])
</script>
